import React, { useState } from 'react';
import { Check } from 'lucide-react';
import LandingNav from '../components/LandingNav';
import LandingFooter from '../components/LandingFooter';
import { authConfig } from '../config/auth';
import '../styles/landing.css';

export default function SupportPage() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${authConfig.apiUrl}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstName,
          lastName,
          companyName,
          email,
          message,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to send message');
      }

      setSuccess(true);
      // Clear form
      setFirstName('');
      setLastName('');
      setCompanyName('');
      setEmail('');
      setMessage('');
      
      // Reset success message after 5 seconds
      setTimeout(() => setSuccess(false), 5000);
    } catch (err: any) {
      setError(err.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="landing-page">
      <LandingNav solid />

      <div className="landing-content">
        <div className="support-container">
          <h1 className="support-title">Get in touch.</h1>

          {success && (
            <div className="support-success-message" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Check size={16} /> Message sent successfully! We'll get back to you soon.
            </div>
          )}

          {error && <div className="support-error-message">{error}</div>}

          <form onSubmit={handleSubmit} className="support-form">
            {/* Name Section */}
            <div className="support-form-group">
              <label className="support-label">
                Name <span className="support-required">(required)</span>
              </label>
              <div className="support-name-row">
                <div className="support-name-field">
                  <label className="support-field-label">First Name</label>
                  <div className="input-container">
                    <input
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      className="input-field"
                      required
                    />
                  </div>
                </div>
                <div className="support-name-field">
                  <label className="support-field-label">Last Name</label>
                  <div className="input-container">
                    <input
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      className="input-field"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Company Section */}
            <div className="support-form-group">
              <label className="support-label">
                Company name <span className="support-required">(required)</span>
              </label>
              <div className="input-container">
                <input
                  type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  className="input-field"
                  required
                  placeholder="e.g. CrewCast"
                />
              </div>
            </div>

            {/* Email Section */}
            <div className="support-form-group">
              <label className="support-label">
                Email <span className="support-required">(required)</span>
              </label>
              <div className="input-container">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input-field"
                  required
                  placeholder="you@example.com"
                />
              </div>
            </div>

            {/* Message Section */}
            <div className="support-form-group">
              <label className="support-label">
                Message <span className="support-required">(required)</span>
              </label>
              <div className="input-container support-textarea-container">
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="input-field support-textarea"
                  required
                  rows={4}
                  placeholder="Tell us how we can help..."
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="support-submit-button"
            >
              {loading ? 'Sending...' : 'Send'}
            </button>
          </form>
        </div>
      </div>
      <LandingFooter />
    </div>
  );
}
